import { render, staticRenderFns } from "./TrangDanhSachGroup.vue?vue&type=template&id=e7c96892&"
import script from "./TrangDanhSachGroup.vue?vue&type=script&lang=js&"
export * from "./TrangDanhSachGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports